import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { EventBus } from '@vtblife/event-bus';
import { useCallback, useEffect, useState } from 'react';
var eventBus = EventBus.getInstance();
export var useEventSubscription = function useEventSubscription(eventType) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    eventData = _useState4[0],
    setEventData = _useState4[1];
  var onClose = useCallback(function () {
    setShowModal(false);
  }, []);
  useEffect(function () {
    var subscription = eventBus.subscribe(eventType, function (_ref) {
      var data = _ref.data;
      setEventData(data);
      setShowModal(function (showModal) {
        return !showModal;
      });
    }, {
      eventCategory: 'simple'
    });
    return function () {
      subscription.unsubscribe();
    };
  }, [eventType, setShowModal]);
  return {
    isOpen: showModal,
    eventData: eventData,
    onClose: onClose
  };
};